export const TEST_ID = 'selectApplicationField';
